import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { getLabelDeliveryType } from './index'
import { grey } from '@material-ui/core/colors';
import CallMadeIcon from '@material-ui/icons/CallMade';
import CallReceivedIcon from '@material-ui/icons/CallReceived';
import { Tooltip } from '@material-ui/core';
import { isCarrierPackk } from '../../../utils/check-carrier';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'center'
  },
  icon: {
    width: 18,
    height: 18,
    padding: 1,
    backgroundColor: grey[600],
    //minWidth: 100,
    marginRight: 5,
    marginBottom: -4,
    color: '#FFFFFF',
    borderRadius: '100%',
  }
});

export default function TipoEntrega(props) {
  const classes = useStyles(props);
  const { tipoEntrega, aguardandoRetirada, transportadora } = props;
  return (
    <Tooltip title={aguardandoRetirada === true && tipoEntrega === "RETIRADA" ? "Aguardando retirada do cliente" : ""}>
      <span className={classes.content}>
        {
          tipoEntrega === 'EXTERNA'
            ? <CallMadeIcon className={classes.icon} fontSize="small" />
            : <CallReceivedIcon className={classes.icon} fontSize="small" />
        }
        {
          !transportadora ?
            (<span>{getLabelDeliveryType(tipoEntrega)}</span>)
            :
            (<span>{!isCarrierPackk(transportadora) ? 'Externa: transportadora' : getLabelDeliveryType(tipoEntrega)}</span>)
        }


      </span>
    </Tooltip>
  );
}